export default __webpack_public_path__ + "static/media/citi.c0b48c18.svg";